import { render, staticRenderFns } from "./UserChannel.vue?vue&type=template&id=49626fa8&scoped=true&"
import script from "./UserChannel.ts?vue&type=script&lang=ts&"
export * from "./UserChannel.ts?vue&type=script&lang=ts&"
import style0 from "./UserChannel.vue?vue&type=style&index=0&id=49626fa8&scoped=true&lang=css&"
import style1 from "./UserChannel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49626fa8",
  null
  
)

export default component.exports